// @flow
import { PuntosActionTypes } from './constants';

type PuntosAction = { type: string, payload: {} | string };

// common success
export const puntosApiResponseSuccess = (actionType: string, data: any): PuntosAction => ({
    type: PuntosActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const puntosApiResponseError = (actionType: string, error: string): PuntosAction => ({
    type: PuntosActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getPunto = (id: string): PuntosAction => ({
    type: PuntosActionTypes.GET_PUNTO,
    payload: { id },
});

export const addPunto = (punto:any):PuntosAction=>({
    type:PuntosActionTypes.ADD_PUNTO,
    payload:punto
})
export const updatePunto = (punto:any):PuntosAction=>({
    type:PuntosActionTypes.UPDATE_PUNTO,
    payload:punto
})
export const deletePunto = (id:string):PuntosAction=>({
    type:PuntosActionTypes.DELETE_PUNTO,
    payload:{id}
})

export const listPuntos = (params:any): PuntosAction => ({
    type: PuntosActionTypes.LIST_PUNTOS,
    payload: params,
});

export const setFiltersPuntos = (params:any): PuntosAction => ({
    type: PuntosActionTypes.SET_FILTER,
    payload: params,
})

export const resetPuntos = (): PuntosAction => ({
    type: PuntosActionTypes.RESET,
    payload: {},
});

